function auditStatusBadge () {
  return {
    restrict: 'E',
    scope: {
      status: '<'
    },
    templateUrl: '/audit/directives/audit-status-badge/audit-status-badge-directive.html?$$REVISION$$'
  }
}

export { auditStatusBadge }
